import fetch from "auth/FetchInterceptor";

const NewOrderService = {};

NewOrderService.create = function (data) {
  return fetch({
    url: "/orders",
    method: "post",
    data,
  });
};

NewOrderService.searchPatient = function (data) {
  return fetch({
    url: "/searchPatient?searchKeyword=" + data,
    method: "get",
  });
};

export default NewOrderService;
